// Data, hora, duração e saudação da tela do PDV. Funções puras — dependem só
// do argumento e do relógio, de nada do componente.

/** "14:5:9" — hora crua, sem zero à esquerda, como a tela sempre mostrou. */
export function formatTime(timeString: any) {
  const date = new Date(timeString);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  return `${hours}:${minutes}:${seconds}`;
}

/** "28/07/2026 - 14:5" */
export function formatDateTime(timeString: any) {
  const date = new Date(timeString);
  const ptBrDate = date.toLocaleDateString("pt-BR");
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return `${ptBrDate} - ${hours}:${minutes}`;
}

/** Quanto tempo faz que o pedido foi aberto: "1h 12m 30s". */
export function getTimeDifference(createdAt: any) {
  const currentTime = new Date();
  const diffInSeconds = Math.floor(
    (currentTime.getTime() - createdAt.getTime()) / 1000
  );

  // Calculate hours, minutes, and seconds
  const hours = Math.floor(diffInSeconds / 3600);
  const minutes = Math.floor((diffInSeconds % 3600) / 60);
  const seconds = diffInSeconds % 60;

  return `${hours}h ${minutes}m ${seconds}s`;
}

/** "Bom dia!" / "Boa tarde!" / "Boa noite!" a partir da hora cheia. */
export function mensagemDeSaudacao(currentHour: number) {
  let greetingMessage = "Bom dia!";
  if (currentHour >= 12 && currentHour < 18) {
    greetingMessage = "Boa tarde!";
  } else if (currentHour >= 18 || currentHour < 4) {
    greetingMessage = "Boa noite!";
  }
  return greetingMessage;
}
